/**
 * Numeric price shown on the store when default currency is XSEED vs other tokens.
 * Falls back to `price` when XSEED but `price_xseed` is unset (legacy rows).
 */
export function getStoreDisplayPrice(product) {
  if (!product) return null;
  const isXseed = product.default_currency?.symbol?.toUpperCase() === "XSEED";
  if (isXseed && product.price_xseed != null && product.price_xseed !== "") {
    const n = Number(product.price_xseed);
    return Number.isFinite(n) ? n : product.price != null ? Number(product.price) : null;
  }
  if (product.price == null || product.price === "") return null;
  const p = Number(product.price);
  return Number.isFinite(p) ? p : null;
}

/**
 * Formats a numeric store price with thousands separators (e.g. 6,302,945).
 */
export function formatStorePrice(value) {
  if (value == null || value === "") return "";
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  return n.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
